import Router from "next/router"

import Head from 'next/head'

var Header=(props)=>(<div style={{padding:"15px"}}>
    <div style={{cursor:"pointer"}} onClick={()=>{document.location.href="/"}}>
        <div style={{fontWeight:500}}>Seva Prem</div>
        <div>онлайн-курсы</div>
    </div>
    <Head>
    <link rel="preload" href="https://fonts.googleapis.com/css?family=Fira+Sans:100,200,300,400,500,600,700,800,900&display=swap&subset=cyrillic-ext" rel="stylesheet"/>
        </Head>
        <style global jsx>{`
            body {
                font-family: 'Fira Sans', sans-serif;
                font-weight:300;
            }
            a {
                color:unset;
                text-decoration:unset;
            }
            a:visited {
                color:unset;
                text-decoration:unset;
            }
            .descriptor {
                padding:15px 0px;
            }
            .elem {
                background-color:#F8F3FC;
                opacity:0.8;
                padding:15px;
                border-radius:7px;
                margin-bottom:15px;
                cursor:pointer
            }
            .elem:hover {
                opacity:1;
            }
            .heading{
                font-size:1.5em;
            }
            .iframe-video{
                width:996px;
                max-width:100%;
                height:560px;
                max-height:100%;
            }
            `}</style>
</div>)

export default Header;